import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './LoanHistory.css'; 
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import ProfileHeader from "../Dashboard/ProfilePage/ProfileHeader";
import { allLeads, getDashboardData } from "../../Utils/api";
import { getStorage, setStorage } from "../../Utils/common";

function LoanHistory() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "", 
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setStorage("pancard", dashboardData?.Data?.profile_details?.pancard);
        const params1 = {
          pancard: getStorage("pancard")
        };
        allLeads(params1).then((resp) => {
          if (resp?.data?.Status === 1) {
            const LeadData = resp?.data?.Data?.lead_list;
            setLeads(LeadData);
          }
        }).catch(error => {
          console.error("Error fetching leads:", error);
        });
      }
    });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleCardClick = (leadId) => {
    // Use navigate to redirect and pass state
    navigate("/my-dashboard/details", { state: { leadId } });
  };

  const statusClass = (s) => {
    const v = String(s || "").toLowerCase();
    if (v.includes("approv") || v.includes("disburs") || v.includes("success") || v.includes("active")) return "lh-status lh-status--green";
    if (v.includes("pend") || v.includes("review") || v.includes("process")) return "lh-status lh-status--amber";
    if (v.includes("reject") || v.includes("declin") || v.includes("fail")) return "lh-status lh-status--red";
    return "lh-status lh-status--gray";
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />

      <div className="lh-section-head">
        <div>
          <h2 className="lh-title">Loan History</h2>
          <p className="lh-sub">All your loan applications in one place</p>
        </div>
        <div className="lh-count">
          <span>{leads.length}</span> {leads.length === 1 ? "Loan" : "Loans"}
        </div>
      </div>

      <div className="loan-history">
        {leads.length > 0 ? (
          leads.map(lead => (
            <div
              key={lead.lead_id}
              className="lh-card"
              onClick={() => handleCardClick(lead.lead_id)}
            >
              <div className="lh-card-top">
                <div className="lh-card-id">
                  <div className="lh-id-ic">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  </div>
                  <div>
                    <div className="lh-id-label">LEAD ID</div>
                    <div className="lh-id-val">#{lead.lead_id}</div>
                  </div>
                </div>
                <span className={statusClass(lead.status)}>
                  <span className="lh-status-dot"></span>
                  {lead.status || "—"}
                </span>
              </div>

              <div className="lh-card-body">
                <div className="lh-stat">
                  <div className="lh-stat-label">Loan Amount</div>
                  <div className="lh-stat-val">₹{Number(lead.loan_amount || 0).toLocaleString('en-IN')}</div>
                </div>
                <div className="lh-stat-sep" />
                <div className="lh-stat">
                  <div className="lh-stat-label">Applied Date</div>
                  <div className="lh-stat-val">{formatDate(lead.lead_entry_date)}</div>
                </div>
              </div>

              <div className="lh-card-foot">
                <span>View Details</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            </div>
          ))
        ) : (
          <div className="lh-empty">
            <div className="lh-empty-ic">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <h3>No loan history yet</h3>
            <p>Once you apply for a loan, your applications will appear here.</p>
          </div>
        )}
      </div>
    </ProfilePreviewWrapper>
  );
}

export default LoanHistory;
